import { jsxs, jsx } from 'react/jsx-runtime';

var Maintain = function Maintain(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === undefined ? '40' : _ref$size;
  return jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [jsx("path", {
      d: "M33.9039 30.5532C34.449 32.5875 32.5875 34.449 30.5533 33.9039L4.02947 26.7968C1.99521 26.2518 1.31386 23.7089 2.80304 22.2197L22.2198 2.80298C23.709 1.3138 26.2518 1.99514 26.7969 4.02941L33.9039 30.5532Z",
      fill: "url(#paint0_linear_3841_41139)"
    }), jsx("path", {
      d: "M26.4129 23.1848C26.9579 25.2191 25.0965 27.0806 23.0622 26.5355L14.8179 24.3264C12.7837 23.7814 12.1023 21.2385 13.5915 19.7493L19.6267 13.7141C21.1159 12.2249 23.6587 12.9063 24.2038 14.9405L26.4129 23.1848Z",
      fill: "url(#paint1_linear_3841_41139)"
    }), jsx("path", {
      d: "M2.19156 25.1567L20.198 20.3318L25.0733 2.16046C24.2878 1.88177 23.3809 1.9565 22.6346 2.46021L2.48871 22.5931C1.9409 23.3735 1.87135 24.3381 2.19156 25.1567Z",
      fill: "url(#paint2_linear_3841_41139)",
      fillOpacity: "0.55"
    }), jsx("path", {
      d: "M33.124 33.265C33.8228 32.6145 34.1863 31.607 33.9039 30.5531L26.7969 4.02933C26.5461 3.0935 25.8726 2.44399 25.0733 2.1604L20.1981 20.3319L33.124 33.265Z",
      fill: "url(#paint3_linear_3841_41139)",
      fillOpacity: "0.35"
    }), jsx("path", {
      d: "M2.19165 25.1568C2.48995 25.9192 3.12639 26.5549 4.02945 26.7969L30.5532 33.9039C31.5377 34.1677 32.4816 33.8679 33.132 33.2577L20.198 20.332L2.19165 25.1568Z",
      fill: "url(#paint4_linear_3841_41139)",
      fillOpacity: "0.25"
    }), jsxs("defs", {
      children: [jsxs("linearGradient", {
        id: "paint0_linear_3841_41139",
        x1: "18.0001",
        y1: "2",
        x2: "18.0001",
        y2: "34",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "#FD5190"
        }), jsx("stop", {
          offset: "1",
          stopColor: "#FD91B9"
        })]
      }), jsxs("linearGradient", {
        id: "paint1_linear_3841_41139",
        x1: "27.6393",
        y1: "27.762",
        x2: "12.9324",
        y2: "13.0551",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "#FD91B9"
        }), jsx("stop", {
          offset: "1",
          stopColor: "#FED3E3"
        })]
      }), jsxs("linearGradient", {
        id: "paint2_linear_3841_41139",
        x1: "19.8281",
        y1: "20.4067",
        x2: "-9.8412",
        y2: "7.49702",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint3_linear_3841_41139",
        x1: "29.4024",
        y1: "34.2155",
        x2: "21.7209",
        y2: "35.6409",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint4_linear_3841_41139",
        x1: "15.33",
        y1: "38.3546",
        x2: "0.319046",
        y2: "31.5818",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      })]
    })]
  });
};

export { Maintain };
